import { Component, ViewEncapsulation, input } from '@angular/core';

@Component({
  selector: 'era-room-status-badge',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './room-status-badge.component.html',
})
export class RoomStatusBadgeComponent {
  readonly isCheckedIn = input.required<boolean>();
}
